module.exports = __webpack_public_path__ + "img/Google-Play-Store.c4849540.png";